import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Shortcuts from "./page/Shortcuts/";
import Application from "./page/Workflow/Application";
import PageApplication from "./page/Workflow/PageApplication";
import QAReject from "./page/ERP/QA/Reject";
import Task from "./page/ERP/Task";
import ManagerReject from "./page/ERP/QA/ManagerReject";
import Stat from "./page/ERP/Stat";
import ERPOrderList from "./page/ERP/Order/List";
import ERPCompletion from "./page/ERP/Completion/Main";
import ERPCompletionHome from "./page/ERP/Completion/Home";
import ERPCompletionHistory from "./page/ERP/Completion/History";
import ERPCompletionHistoryNew from "./page/ERP/Completion/HistoryNew"; //新填报记录
import ERPCompletionHistoryNewDetail from "./page/ERP/Completion/HistoryNew/Detail"; //新填报记录明细
import CompletionListAgain from "./page/ERP/Completion/HistoryNew/CompletionListAgain"; //再次填报
import ERPCompletionTransfer from "./page/ERP/Completion/Transfer"; //转移清单
import ERPOrderDetail from "./page/ERP/Order/Detail";
import ERPOrderImage from "./page/ERP/Order/Image";
import RejectHistory from "./page/ERP/QA/RejectHistory";
import StatHistory from "./page/ERP/Stat/StatHistory";
import ZhengBaoOrder from "./page/Tenant/Order";
import ZhengBaoOrderEcho from "./page/Tenant/Order/OrderEcho";
import EnterpriseDetails from "./page/CRM/Customer/EnterpriseDetails";
import Board from "./page/ERP/Board";
import LoginList from "./page/HR/login/index";
import IndexList from "./page/HR/HomePage/index";
import MineList from "./page/HR/mine/index";
import TestProject from "./page/HR/XhomePage/index";
import MoreNoticeList from "./page/HR/HomePage/morenotice";
import MailList from "./page/HR/MailList/index";
import MailDetailsList from "./page/HR/MailList/details";
import HomePageList from "./page/HR/HomePage/shouye";
import MyqueryList from "./page/HR/MyQuery/index";
import Achievements from "./page/HR/MyQuery/achievements";
import Attendance from "./page/HR/MyQuery/Attendance";
import JxAssessment from "./page/HR/JxAssessment/index";
import MonthAssessment from "./page/HR/JxAssessment/MonthAssessment";
import YearAssessment from "./page/HR/JxAssessment/YearAssessment";
import MonthDetails from "./page/HR/JxAssessment/MonthAssessment/details";
import OrganizationAssessment from "./page/HR/JxAssessment/YearAssessment/organization";
import KhOrganization from "./page/HR/JxAssessment/YearAssessment/khorganization";
import StaffAssessment from "./page/HR/JxAssessment/YearAssessment/staff";
import KhStaff from "./page/HR/JxAssessment/YearAssessment/khstaff";
import RankAdjustment from "./page/HR/RankAdjustment/index";
import PromotionManagement from "./page/HR/RankAdjustment/PromotionManagement";
import PromotionDetails from "./page/HR/RankAdjustment/PromotionManagement/details";
import Suspension from "./page/HR/RankAdjustment/suspension";
import VotingDetails from "./page/HR/RankAdjustment/suspension/VotingDetails";
import Chart from "./page/Chart";
import Analysis from "./page/Chart/Analysis";

// 泌尿App
import ReadDetail from "./page/Tenant/Doctor/ReadDetail";
import ScoreWord from "./page/Tenant/Doctor/ScoreWord";
import Result from "./page/Tenant/Doctor/NewResult";
//图纸
import DrawingList from "./page/ERP/Drawing/list";
import QueryList from "./page/ERP/Drawing/querylist";

// 网站注册
import WebsiteRegister from "./page/WebsiteRegister";
import AuthLoading from "./page/EnterpriseWechat/AuthLoading";
import { FastGrid } from "./page/FastGrid";
import Register from "./page/Register";
import Tiktok from "./page/Register/Tiktok";
import RegisterWithDownload from "./page/Register/WithDownload";
import RegisterQRCode from "./page/Register/registrtQRCode";
import Success from "./page/Register/Success";
import Download from "./page/Register/Download";
import Faster from "./page/Register/Faster"; //一键注册
import VideoShow from "./page/Register/VideoShow"; //播放引导视频
//外出考勤
import OutsideSignNew from "./page/Punch/OutsideSignNew";
import GetLatAndLon from "./page/Punch/GetLatAndLon";
import DailyReport from "./page/Tenant/Lions/DailyReport";
// const TablegridAdd = lazy(
//   () => import("./page/EnterpriseWechat/CustomersAndGroups/Customer/TableAdd")
// );
const WechatMaterial = lazy(() => import("./page/EnterpriseWechat/Material"));

const MaterialInfo = lazy(
  () => import("./page/EnterpriseWechat/Material/MaterialInfo")
);
const MaterialSendPage = lazy(
  () => import("./page/EnterpriseWechat/MaterialSendPage")
);
const WechatMaterialViewer = lazy(
  () => import("./page/EnterpriseWechat/Material/ViewerRoute")
);
//新增详情页面
const MaterialDetail = lazy(
  () => import("./page/EnterpriseWechat/Material/Detail")
);
const WechatCustomerList = lazy(
  () => import("./page/EnterpriseWechat/CustomersAndGroups/Customer/List")
);
const WechatCustomerDetail = lazy(
  () => import("./page/EnterpriseWechat/CustomersAndGroups/Customer/Detail")
);
const WechatHuaShu = lazy(() => import("./page/EnterpriseWechat/HuaShu"));
const CustomerBase = lazy(
  () => import("./page/EnterpriseWechat/CustomersAndGroups/CustomerBase/List")
);
const CustomerBaseDetails = lazy(
  () =>
    import("./page/EnterpriseWechat/CustomersAndGroups/CustomerBase/Details")
);
const CustomerBaseSearch = lazy(
  () => import("./page/EnterpriseWechat/CustomersAndGroups/CustomerBase/Search")
);
const CustomerBaseCheckList = lazy(
  () =>
    import(
      "./page/EnterpriseWechat/CustomersAndGroups/CustomerBase/GroupCheckList"
    )
);
const CustomerCheckList = lazy(
  () => import("./page/EnterpriseWechat/CustomersAndGroups/Customer/CheckList")
);

const CustomersAndGroups = lazy(
  () => import("./page/EnterpriseWechat/CustomersAndGroups/")
);
//企业微信h5
const Wflist = lazy(() => import("./page/Wf/List"));
const NewFormList = lazy(() => import("./page/Wf/NewFormList"));
//h5表单
const FormList = lazy(() => import("./page/Wf/Form/List"));
// 医生端阅读详情
const DoctorReadDetail = lazy(
  () => import("./page/Tenant/Doctor/DoctorEnd/ReadDetail")
);
//智能卡片
const Business = lazy(() => import("./page/Business"));
const Personal = lazy(() => import("./page/Business/Personal/index"));
const PersonalEditor = lazy(() => import("./page/Business/Personal/Editor"));
const OpenMaterialDetail = lazy(
  () => import("./page/Business/component/OpenDetail")
);
const EnterpriseDetail = lazy(() => import("./page/Business/Enterprise"));
const ContactsList = lazy(
  () => import("./page/Business/component/ContactsList")
);
const VisitorDetail = lazy(
  () => import("./page/Business/Personal/visitor/Details")
);
const VisitorSearch = lazy(
  () => import("./page/Business/Personal/visitor/Search")
);
const Datalist = lazy(() => import("./page/Business/Personal/Datalist"));
// import DoctorReadDetail from "./page/Tenant/Doctor/DoctorEnd/ReadDetail";

const EnterpriseFission = lazy(
  () => import("./page/EnterpriseWechat/MarketingMix/EnterpriseFission/")
);

const EFRecordList = lazy(
  () =>
    import("./page/EnterpriseWechat/MarketingMix/EnterpriseFission/RecordList")
);
//新增订单
const AddOrder = lazy(() => import("./page/Tenant/Order/component/AddOrder"));
//订单详情
const OrderDetail = lazy(
  () => import("./page/Tenant/Order/component/OrderDetail")
);
//订单详情
const AddTrends = lazy(() => import("./page/Chart/component/AddTrends"));

const loadingStyle = {
  display: "flex",
  justifyContent: "center",
  height: "100vh",
  alignItems: "center",
};

function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <div style={loadingStyle}>
            <img width={32} height={32} src="/loading.webp" alt="" />
          </div>
        }
      >
        <Switch>
          <Route path="/enterpriseFission">
            <EnterpriseFission />
          </Route>

          <Route path="/efRecordList">
            <EFRecordList />
          </Route>

          <Route path="/MaterialInfo">
            <MaterialInfo />
          </Route>
          <Route path="/MaterialSendPage">
            <MaterialSendPage />
          </Route>
          <Route path="/CustomersAndGroups/:type">
            <CustomersAndGroups />
          </Route>
          <Route path="/customerBase">
            <CustomerBase />
          </Route>
          {/*
            /customerBase-details/{id}?from="list
            from: list 从列表点击
            form： wx 微信菜单点击
          */}
          <Route path="/customerBase-details/:id">
            <CustomerBaseDetails />
          </Route>
          <Route path="/customerBase-search">
            <CustomerBaseSearch />
          </Route>
          <Route path="/customerBase-checkList">
            <CustomerBaseCheckList />
          </Route>
          <Route path="/customer-checkList">
            <CustomerCheckList />
          </Route>

          <Route path="/business/personal/visitor/details/:userId/:corpId/:cardId/:uuid">
            <VisitorDetail />
          </Route>
          <Route path="/business/personal/visitor/search/:userId/:corpId/:cardId">
            <VisitorSearch />
          </Route>
          <Route path="/business/contacts/list/:corpId/:userId/:status">
            <ContactsList />
          </Route>
          <Route path="/business/enterprise/detail/:corpId/:userId/:status">
            <EnterpriseDetail />
          </Route>
          <Route path="/business/openMaterialDetail/:uuid/:userId/:corpId/:type/:cardId">
            <OpenMaterialDetail />
          </Route>
          <Route path={"/wf/form/:workflowTemplateId/:id"}>
            <FormList />
          </Route>
          <Route path={"/business/personal/editor/:userId/:corpId/:type"}>
            <PersonalEditor />
          </Route>
          <Route path={"/business/personal/:userId/:corpId/:type"}>
            <Personal />
          </Route>
          <Route path={"/business/datalist/:userId/:corpId/:cardId/:type"}>
            <Datalist />
          </Route>
          <Route path={"/business"}>
            <Business />
          </Route>
          <Route path={"/doctor/readDetail"}>
            <ReadDetail />
          </Route>
          <Route path={"/doctor/doctorReadDetail"}>
            <DoctorReadDetail />
          </Route>
          <Route path={"/doctor/scoreWord"}>
            <ScoreWord />
          </Route>
          <Route path={"/doctor/result/:value/:type"}>
            <Result />
          </Route>
          <Route path={"/shortcuts"}>
            <Shortcuts />
          </Route>
          <Route path={"/wf/application/:workflowTemplateId/:pageMaxSize"}>
            <Application />
          </Route>
          <Route path={"/wf/pageApplication/:workflowTemplateId"}>
            <PageApplication />
          </Route>
          <Route path={"/erp/qa/reject"}>
            <QAReject />
          </Route>
          <Route path={"/erp/task/assign"}>
            <Task />
          </Route>
          <Route path={"/erp/qa/manager"}>
            <ManagerReject />
          </Route>
          <Route path={"/erp/qa/history"}>
            <RejectHistory />
          </Route>
          <Route path={"/erp/stat/history"}>
            <StatHistory />
          </Route>
          <Route path={"/erp/stat"} exact={true}>
            <Stat />
          </Route>
          <Route path={"/erp/board"} exact={true}>
            <Board />
          </Route>
          <Route path={"/erp/order"} exact={true}>
            <ERPOrderList />
          </Route>
          <Route path={"/erp/completion/home"} exact={true}>
            <ERPCompletionHome />
          </Route>
          <Route path={"/erp/completion"} exact={true}>
            <ERPCompletion />
          </Route>
          <Route path={"/erp/completion/history"} exact={true}>
            <ERPCompletionHistory />
          </Route>
          <Route path={"/erp/completion/historyNew"} exact={true}>
            <ERPCompletionHistoryNew />
          </Route>
          <Route path={"/erp/completion/transfer"} exact={true}>
            <ERPCompletionTransfer />
          </Route>
          <Route
            path={"/erp/completion/historyNew/detail/:fillingId"}
            exact={true}
          >
            <ERPCompletionHistoryNewDetail />
          </Route>
          <Route
            path={"/erp/completion/historyNew/completionListAgain/:fillingId"}
            exact={true}
          >
            <CompletionListAgain />
          </Route>

          <Route path={"/erp/order/detail/:tableName/:uuid/:name"} exact={true}>
            <ERPOrderDetail />
          </Route>
          <Route path={"/erp/order/image/:uuid/:name"} exact={true}>
            <ERPOrderImage />
          </Route>
          <Route path={"/erp/drawinglist"} exact={true}>
            <DrawingList />
          </Route>
          <Route path={"/erp/drawinglist/querylist"} exact={true}>
            <QueryList />
          </Route>
          <Route path={"/tenant/lions/daily-report"} exact>
            <DailyReport />
          </Route>
          <Route path={"/tenant/zhengbao/order"} exact>
            <ZhengBaoOrder />
          </Route>
          <Route path={"/tenant/zhengbao/order/detail"}>
            <ZhengBaoOrderEcho />
          </Route>
          <Route path={"/tenant/order/addorder"}>
            <AddOrder />
          </Route>
          <Route path={"/tenant/order/orderDetail"}>
            <OrderDetail />
          </Route>
          <Route path={"/crm/enterprise/details/:name"}>
            <EnterpriseDetails />
          </Route>
          <Route path={"/hr/login"}>
            <LoginList />
          </Route>
          <Route path={"/hr/index"}>
            <IndexList />
          </Route>
          <Route path={"/hr/application"}>
            <TestProject />
          </Route>
          <Route path={"/hr/homepage"} exact>
            <HomePageList />
          </Route>
          <Route path={"/hr/homepage/morenotice"}>
            <MoreNoticeList />
          </Route>
          <Route path={"/hr/mine"}>
            <MineList />
          </Route>
          <Route path={"/hr/maillist"}>
            <MailList />
          </Route>
          <Route path={"/hr/maildetailslist"}>
            <MailDetailsList />
          </Route>
          <Route path={"/hr/myquery"}>
            <MyqueryList />
          </Route>
          <Route path={"/hr/achievements"}>
            <Achievements />
          </Route>
          <Route path={"/hr/attendance"}>
            <Attendance />
          </Route>
          <Route path={"/hr/jxassessment"} exact>
            <JxAssessment />
          </Route>
          <Route path={"/hr/jxassessment/monthassessment"} exact>
            <MonthAssessment />
          </Route>
          <Route path={"/hr/jxassessment/yearassessment"} exact>
            <YearAssessment />
          </Route>
          <Route path={"/hr/jxassessment/monthassessment/details"}>
            <MonthDetails />
          </Route>
          <Route path={"/hr/jxassessment/yearassessment/organization"} exact>
            <OrganizationAssessment />
          </Route>
          <Route path={"/hr/jxassessment/yearassessment/staff"} exact>
            <StaffAssessment />
          </Route>
          <Route path={"/hr/jxassessment/yearassessment/organization/details"}>
            <KhOrganization />
          </Route>
          <Route path={"/hr/jxassessment/yearassessment/staff/details"}>
            <KhStaff />
          </Route>
          <Route path={"/hr/rankadjustment"} exact>
            <RankAdjustment />
          </Route>
          <Route path={"/hr/rankadjustment/promotionmanagement"} exact>
            <PromotionManagement />
          </Route>
          <Route path={"/hr/rankadjustment/promotionmanagement/details"} exact>
            <PromotionDetails />
          </Route>
          <Route path={"/hr/rankadjustment/suspension"} exact>
            <Suspension />
          </Route>
          <Route path={"/hr/rankadjustment/suspension/votingdetails"} exact>
            <VotingDetails />
          </Route>
          <Route path={"/chart"}>
            <Chart />
          </Route>
          <Route path={"/analysis"}>
            <Analysis />
          </Route>
          <Route path={"/char/trend/addTrends"} exact>
            <AddTrends />
          </Route>
          <Route path={"/wf"} exact>
            <Wflist />
          </Route>
          <Route path={"/wf/newformlist"}>
            <NewFormList />
          </Route>

          <Route path={"/websiteregister"}>
            <WebsiteRegister />
          </Route>

          <Route path={"/chat/customer/list"}>
            <WechatCustomerList />
          </Route>

          <Route path={"/huashu"}>
            <WechatHuaShu />
          </Route>
          <Route path={"/material"}>
            <WechatMaterial />
          </Route>
          <Route
            path={"/page/material/detail/:uuid/:corpId/:staffId/:customerId"}
          >
            <MaterialDetail />
          </Route>
          <Route path={"/material-viewer/:type/:id"}>
            <WechatMaterialViewer />
          </Route>
          <Route path={"/chat/customer/detail"}>
            <WechatCustomerDetail />
          </Route>
          <Route path={"/wework/loading"}>
            <AuthLoading />
          </Route>
          <Route path={"/fast/grid/:uuid"}>
            <FastGrid />
          </Route>
          <Route path={"/register"}>
            <Register />
          </Route>
          <Route path={"/registerTiktok"}>
            <Tiktok />
          </Route>

          <Route path={"/registerWithDownload"}>
            <RegisterWithDownload />
          </Route>
          <Route path={"/registerQRCode"}>
            <RegisterQRCode />
          </Route>
          <Route path={"/faster"}>
            <Faster />
          </Route>
          <Route path={"/videoShow/:videoId/:width/:height"}>
            <VideoShow />
          </Route>
          <Route path={"/outsideSignNew/:uuid/:corpId/:mLong/:mLati"}>
            <OutsideSignNew />
          </Route>
          <Route path={"/getLatAndLon"}>
            <GetLatAndLon />
          </Route>
          <Route path={"/success"}>
            <Success />
          </Route>
          <Route path={"/download"}>
            <Download />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
